import axios from "axios";
import { message } from "antd";

const API_BASE_URL_RAW =
  process.env.REACT_APP_API_URL || "https://myorder.skysourcesolution.com/api";

export const API_BASE_URL = API_BASE_URL_RAW.replace(/\/$/, "");
/** Same base as the API; uploads resolve to `${STORAGE_BASE_URL}/storage/...` (e.g. …/api/storage/settings/…). */
export const STORAGE_BASE_URL = API_BASE_URL.replace(/\/$/, "");

// Create an axios instance with the base URL
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

// Function to get the full API URL for a specific endpoint
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Build absolute URL for files served from /storage.
export const getStorageUrl = (filePath) => {
  if (!filePath) return "";
  let cleanPath = String(filePath).replace(/^\/+/, "").replace(/\\/g, "/");
  if (cleanPath.startsWith("storage/")) {
    cleanPath = cleanPath.slice("storage/".length);
  }
  return `${STORAGE_BASE_URL}/storage/${cleanPath}`;
};

// Add a request interceptor to handle authentication tokens
apiClient.interceptors.request.use(
  (config) => {
    const raw = localStorage.getItem("sessionToken");
    const token = typeof raw === "string" ? raw.trim() : "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const SESSION_EXPIRED_EVENT = "velan:session-expired";

// Add a response interceptor for centralized error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const skipAuthRedirect = Boolean(error?.config?.skipAuthRedirect);
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401 && !skipAuthRedirect) {
        window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
      } else if (status === 403) {
        message.error(data?.message || "You do not have permission to perform this action.");
      }
      console.error(`API Error (${status}):`, data);
    } else if (error.request) {
      console.error('API Error: No response received', error.request);
    } else {
      console.error('API Error:', error.message);
    }
    return Promise.reject(error);
  }
);

// API helper functions
export const API_BASEURL = async () => {
  try {
    const res = await apiClient.get('/');
    return res.data;
  } catch (error) {
    console.error("Error fetching API base data:", error);
    throw error;
  }
};

export const fetchAnalyticsData = async () => {
  try {
    const res = await apiClient.get('/reports');
    return res.data;
  } catch (error) {
    console.error("Error fetching analytics data:", error);
    throw error;
  }
};
